<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area cs-courseSchedule-content">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="日期" label-width="150px">
          <span>{{ dataIn.date }}</span>
        </el-form-item>
        <el-form-item label="校区" label-width="150px">
          <span>{{ dataIn.campus }}</span>
        </el-form-item>
        <el-form-item label="电脑" label-width="150px">
          <span>{{ form.computerName }}</span>
        </el-form-item>
        <el-form-item label="开始时间" label-width="150px">
          <el-col :span="10">
            <el-select v-model="form.startTime" :clearable="true" size="small" placeholder="开始时间"
              @change="startTimeChanged">
              <el-option v-for="item in timesOfStartTime" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="预约时长" label-width="150px">
          <el-col :span="10">
            <span v-show="dataIn.isOwnDevice">{{ minutesText }}</span>
            <el-select v-show="!dataIn.isOwnDevice" size="small" v-model="form.minutes" placeholder="请选择时长" @change="onTimeLengthChange">
              <el-option v-for="(item, index) in dataIn.timeLengthList" :key="index" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="结束时间" label-width="150px">
          <span>{{ form.endTimeText }}</span>
        </el-form-item>
      </el-form>
      <div class="errorMessage-container">
        <el-row>
          <el-col :span="22">
            <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
          </el-col>
        </el-row>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="12" class="footer-left">
          <el-button v-if="dataIn.isEdit" type="danger" @click="deleteTime()">删 除</el-button>
        </el-col>
        <el-col class="footer-right" :span="12">
          <el-button type="primary" @click="save()">保存</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-courseSchedule-editor {
  .cs-courseSchedule-content {
    position: relative;

    .errorMessage-container {
      position: absolute;
      bottom: 5px;
      width: 100%;
    }

    .cs-import-message {
      font-weight: bold;
      color: red;
    }
  }

  .popup-footer {
    padding: 0 50px;
    margin-right: 0;

    .footer-left {
      span {
        display: inline-block;
        width: 1px;
      }
    }

    .footer-right {
      text-align: right;
    }
  }
}

.el-form-item {
  margin-bottom: 0px;
}
</style>

<script>
import { formatTimeToInt60, formatTimeFromInt60 } from "../../config/mUtils";
import { srcTimesOfDay } from "../../service/api-base.service";
import {
  saveStudentCourse,
  deleteStudentCourse
} from "../../service/course.service";
import { removeCampus } from "../../service/common.service";
export default {
  data() {
    return {
      computerAvailableScheduleList: [],
      timesOfDay: srcTimesOfDay(false),
      errorMessage: "",
      showError: false,
      minTime: formatTimeToInt60("8:00 AM"),
      maxTime: formatTimeToInt60("11:00 PM"),
      timesOfStartTime: [],
      availableSchedule: null,
      minutesText: "",
      form: {
        startTime: "",
        endTime: "",
        endTimeText: "",
        computerId: "",
        computerName: "",
        minutes: 0
      },
      rules: {
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur"
          }
        ],
        endTime: [
          {
            required: true,
            message: "结束时间不可用",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  created() {
    this.init();
  },
  props: {
    dataIn: {
      id: String | Number,
      isEdit: Boolean,
      date: String,
      campus: String,
      computerId: Number,
      computerName: String,
      unavailableTime: Array,
      startTime: String,
      minutes: Number, //预约分钟数
      isOwnDevice: Boolean,
      fixedTimeRange: Boolean,
      minTime: Number,
      maxTime: Number,
      availableScheduleList: Array,
      computerSchedulesData: Array,
      computerList: Array,
      timeLengthList: Array
    }
  },
  methods: {
    init() {
      let isSetTime = false;
      this.computerAvailableScheduleList = [];
      this.form.computerId = "";
      this.form.computerName = "";
      this.form.minutes = "";
      this.form.startTime = "";
      this.form.endTime = "";
      this.form.endTimeText = "";
      if (!!this.dataIn && this.dataIn.availableScheduleList) {
        this.form.computerName = this.dataIn.computerName;
        this.availableSchedule = null;
        this.minTime = this.dataIn.minTime;
        this.maxTime = this.dataIn.maxTime;
        
        if (this.dataIn.minutes === 0){
          this.form.minutes = "";
        }else{
          this.form.minutes = this.dataIn.minutes;
        }
        this.minutesText = formatTimeFromInt60(this.dataIn.minutes, true);
        if (!this.form.isOwnDevice && this.dataIn.timeLengthList.length > 0){
          let hasMinutes = true;
          if (!this.form.minutes){
            hasMinutes = false;
          } else {
            let index = this.dataIn.timeLengthList.findIndex(i => i.value === this.form.minutes);
            hasMinutes = index >= 0;
          }
          //if (!hasMinutes){
          //  this.form.minutes = this.dataIn.timeLengthList[this.dataIn.timeLengthList.length - 1].value;
          //}
        }
              
        if (this.dataIn.computerId){
          this.form.computerId = this.dataIn.computerId;
          this.form.computerName = this.dataIn.computerName;

          if (this.dataIn.fixedTimeRange && !this.dataIn.isOwnDevice){
            this.computerAvailableScheduleList = this.dataIn.availableScheduleList[this.dataIn.computerId];//.filter(i => i.ComputerId == this.dataIn.computerId);
          }
        }

        if (this.dataIn.startTime && !!this.form.minutes){
          let startTimeValue = formatTimeToInt60(this.dataIn.startTime);
          let endTimeValue = this.getEndTime(startTimeValue); 

          if (this.validateTime(startTimeValue, endTimeValue)) {
            this.form.startTime = startTimeValue;
            this.form.endTime = endTimeValue;
            this.form.endTimeText = formatTimeFromInt60(endTimeValue);
            isSetTime = true;
          }
        }
      }
      this.loadTimeList();
    },
    loadTimeList() {
      let list = [];
      let maxTime = this.maxTime;
      if (this.dataIn.isOwnDevice){
        maxTime = this.maxTime - this.form.minutes;
      }
      this.timesOfDay.forEach(element => {
        let disabled = false;
        if (element.value < this.minTime) {
          return;
        }

        if (
          element.value < this.minTime ||
          element.value > maxTime ||
          element.value >= this.maxTime
          //element.value + this.dataIn.minutes > this.maxTime
        ) {
          disabled = true;
        } else {
          if (
            !!this.dataIn &&
            !!this.dataIn.unavailableTime &&
            this.dataIn.unavailableTime.length > 0
          ) {
            let index = -1;
            if (this.dataIn.isOwnDevice){
              index = this.dataIn.unavailableTime.findIndex(
                i =>
                  element.value >= i.startTime &&
                  element.value < i.endTime
              );
            }else{
              index = this.dataIn.unavailableTime.findIndex(
                i =>
                  //每一个不可用的时间段，开始时间往前预约分钟数到结束时间，都不可用
                  //e.g. 10:00 - 11:00, 分钟数60，那么 9:30 - 11:00 都不可用
                  //element.value > i.startTime - this.dataIn.minutes &&
                  element.value >= i.startTime && //重新调整为10:00 - 11:00 都不可用
                  element.value < i.endTime
              );
            }
             
            if (index >= 0) {
              disabled = true;
            }
          }

          if (
            !!this.dataIn &&
            !!this.computerAvailableScheduleList &&
            this.computerAvailableScheduleList.length > 0
          ) {
            let index = this.computerAvailableScheduleList.findIndex(i => i.StartTimeMinutes == element.value);
            if (index < 0) {
              disabled = true;
            }
          }
        }
        element.disabled = disabled;
        list.push(element);
      });

      this.timesOfStartTime = list;
    },
    getfixedEndTime(startTimeValue) {
      if (!!startTimeValue && !!this.dataIn && !!this.computerAvailableScheduleList && this.computerAvailableScheduleList.length > 0) {
        this.availableSchedule = this.computerAvailableScheduleList.find(i => i.StartTimeMinutes == startTimeValue);
        if (!!this.availableSchedule) {
          return this.availableSchedule.EndTimeMinutes;
        }
        //return startTime + this.dataIn.minutes;
      } else {
        this.availableSchedule = null;
      }
      return 0;
    },
    getEndTime(startTimeValue){
      let endTimeValue = 0;
      if (this.dataIn.fixedTimeRange && !this.dataIn.isOwnDevice){
        endTimeValue = this.getfixedEndTime(startTimeValue); 
      }else{
        endTimeValue = startTimeValue + this.form.minutes;
      }
      return endTimeValue;
    },
    setEndTime(){
      if (!!this.form.startTime) {
        let endTimeValue = this.getEndTime(this.form.startTime);   
        let isValid = true;
        let endTimeText = formatTimeFromInt60(endTimeValue); 
        if (endTimeValue > this.maxTime){
          isValid = false;
          this.$message.error(`选择的预约时间结束时间${endTimeText}超出可用时间范围，请选择其他时间`);
        } else{ 
          isValid = this.validateTime(this.form.startTime, endTimeValue, true);
          if (isValid && !this.dataIn.fixedTimeRange && !this.dataIn.isOwnDevice){
            let selectedComputer = this.getComputer(this.form.startTime, endTimeValue);
            if (!selectedComputer){
              isValid = false;
              let startTimeText = formatTimeFromInt60(this.form.startTime);
              this.$message.error(`选择的预约时间${startTimeText}-${endTimeText}范围内无可用的电脑，请选择其他时间`);
            }else{
              this.form.computerId = selectedComputer.Id;
              this.form.computerName = selectedComputer.ComputerName;
            }
          }
        }
        if (isValid) {
          this.form.endTime = endTimeValue;
          this.form.endTimeText = endTimeText;
        } else {
          this.form.endTime = "";
          this.form.endTimeText = "";
        }
      }
    },
    startTimeChanged() {
      this.setEndTime();
    },
    onTimeLengthChange(){
      this.setEndTime();
    },
    deleteTime() {
      this.$confirm("您确认要删除该预约吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$emit("delete", this.dataIn.id);
        })
        .catch(() => { });
    },
    save() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) isValid = false;
      });
      if (!isValid) {
        return false;
      }

      if (!this.form.startTime) {
        this.$message.warning("开始时间未设置");
        return false;
      }

      if (!this.form.endTime) {
        this.$message.warning("结束时间未设置");
        return false;
      }

      if (!this.form.computerId){
        this.$message.warning("无可用电脑");
        return false;
      }

      if (!this.dataIn.isOwnDevice && this.dataIn.fixedTimeRange && !this.availableSchedule) {
        this.$message.warning("没有可用的时间");
        return false;
      }

      if (this.availableSchedule && this.dataIn.fixedTimeRange && this.availableSchedule.IsGap) {
        let startTimeText = formatTimeFromInt60(this.form.startTime);
        let endTimeText = formatTimeFromInt60(this.form.endTime);
        this.$confirm("您预约的时间(" + startTimeText + "-" + endTimeText + ")少于视频长度(" + this.form.minutes + "分钟)，您有可能无法观看完整视频，请确认是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.saveData();
          })
          .catch(() => { });
      } else {
        this.saveData();
      }
    },
    saveData() {
      if (!this.form.minutes){
        this.$message.warning("请选择预约时长");
        return;
      }
      let data = {
        id: this.dataIn.id,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        computerId: this.form.computerId,
        computerName: this.form.computerName,
        minutes: this.form.minutes
      };
      this.$emit("save", data);
    },
    validateTime(startTime, endTime, showMessage) {
      
      if (startTime < this.minTime || endTime > this.maxTime) {
        if (showMessage){
          let message = "";
          if (startTime < this.minTime){
            let startTimeDesc = formatTimeFromInt60(startTime);
            let minTimeDesc = formatTimeFromInt60(this.minTime);
            message = `开始时间${startTimeDesc}小于最早时间${minTimeDesc}`;
          } else{
            let endTimeDesc = formatTimeFromInt60(endTime);
            let maxTimeDesc = formatTimeFromInt60(this.maxTime);
            message = `结束时间${endTimeDesc}大于最晚时间${maxTimeDesc}`;
          }
          this.$message.warning(message);
        }
        return false;
      }

      let index = this.dataIn.unavailableTime.findIndex(i => i.startTime < endTime && i.endTime > startTime);
      if (index >= 0) {
        if (showMessage){
          let item = this.dataIn.unavailableTime[index];
          let unavailableTimeRange = `${formatTimeFromInt60(item.startTime)} - ${formatTimeFromInt60(item.endTime)}`;
          let message = "";
          if (item.isSchedule){
            message = `当前选择时间段与其他已安排预约时间段${unavailableTimeRange}重叠`;
          }else{
            message = `时间段${unavailableTimeRange}不可用`;
          }
          this.$message.warning(message);
        }
        return false;
      }

      return true;
    },
    getComputer(startTime, endTime){
      if (this.dataIn && this.dataIn.computerList && this.dataIn.availableScheduleList){
        for(let i = 0; i < this.dataIn.computerList.length; i ++){
          let computer = this.dataIn.computerList[i];
          //检查时间段是否可用
          let isAvailable = this.dataIn.availableScheduleList[computer.Id].findIndex(
            i => startTime >= i.StartTimeMinutes && endTime <= i.EndTimeMinutes) >= 0;
          //检查时间段是否与其他计划重叠
          let isOverlap = this.dataIn.computerSchedulesData[computer.Id].findIndex(
            i => i.StartTimeMinutes < endTime && i.EndTimeMinutes > startTime && i.Id !== this.dataIn.id) >= 0;
           
          if (isAvailable && !isOverlap){
            return computer;
          }
        }
      }
      return null;
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappSelectTimeEdit.vue